/*
 * Custom product-gallery zoom lightbox.
 *
 * Opens on click of a main gallery image (img.product-media__image inside
 * [data-product-media-container]), shows a fullscreen popup with zoom (wheel /
 * buttons / double-click / pinch) and pan (drag), plus prev/next + keyboard.
 *
 * Opens instantly with the image already on screen, then swaps in a 2048px
 * hi-res version once it has loaded in the background.
 *
 * Markup + styles live in snippets/product-zoom-lightbox.liquid. The media
 * list is read from the [data-pzoom-data] JSON on each open, so it stays
 * correct even if the product section is re-rendered (variant change, etc.).
 */
(function () {
  var overlay = document.getElementById('pzoom');
  if (!overlay) return;

  var img = overlay.querySelector('[data-pzoom-img]');
  var stage = overlay.querySelector('[data-pzoom-stage]');
  var pctEl = overlay.querySelector('[data-pzoom-pct]');
  var countEl = overlay.querySelector('[data-pzoom-count]');
  var captionEl = overlay.querySelector('[data-pzoom-caption]');

  var media = [];
  var idx = 0;
  var scale = 1, panX = 0, panY = 0;
  var pointers = {}, startDist = 0, startScale = 1;
  var dragId = null, dragOX = 0, dragOY = 0, dragPX = 0, dragPY = 0;
  // Horizontal swipe at scale 1. Start point of the single pointer, or null
  // once a second finger joins -- a pinch never turns into a page change.
  var swipe = null;
  var SWIPE_MIN = 50;

  var MIN = 1, MAX = 4;

  function readData() {
    var el = document.querySelector('[data-pzoom-data]');
    if (!el) return [];
    var list;
    try { list = JSON.parse(el.textContent); } catch (e) { return []; }
    // Anything can swap an entry's image out before the viewer opens -- the
    // colour configurator uses this to show the recoloured canvas instead of
    // the stock photo. Called once per open, never per repaint, so an override
    // that costs a canvas export is affordable here.
    if (typeof window.pzoomOverride === 'function') {
      try { list = window.pzoomOverride(list) || list; } catch (e2) {}
    }
    return list;
  }

  function indexOfMediaId(list, mid) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(mid)) return i;
    }
    return -1;
  }

  function norm(u) {
    try { return new URL(u, window.location.href).pathname; }
    catch (e) { return (u || '').split('?')[0]; }
  }

  function clampPan() {
    var maxX = (scale - 1) * (stage.clientWidth / 2);
    var maxY = (scale - 1) * (stage.clientHeight / 2);
    if (panX > maxX) panX = maxX; else if (panX < -maxX) panX = -maxX;
    if (panY > maxY) panY = maxY; else if (panY < -maxY) panY = -maxY;
  }

  function apply(anim) {
    clampPan();
    img.style.transition = anim ? 'transform .18s ease' : 'none';
    img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    pctEl.textContent = Math.round(scale * 100) + '%';
    stage.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
  }

  function setScale(s, anim) {
    scale = Math.max(MIN, Math.min(MAX, s));
    if (scale === MIN) { panX = 0; panY = 0; }
    apply(anim !== false);
  }

  function load(immediate) {
    var m = media[idx];
    if (!m) return;
    scale = 1; panX = 0; panY = 0;
    img.alt = m.alt || '';
    img.src = immediate || m.src;
    var hi = new Image();
    hi.onload = function () { if (media[idx] === m) img.src = m.full; };
    hi.src = m.full;
    countEl.textContent = (idx + 1) + ' / ' + media.length;
    setNav();
    if (captionEl) {
      captionEl.textContent = m.caption || '';
      captionEl.hidden = !m.caption;
    }
    apply(false);
  }

  function openAt(i, immediate) {
    media = readData();
    if (!media.length) return;
    idx = Math.max(0, Math.min(media.length - 1, i));
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    load(immediate);
  }

  // A single image has nowhere to go: no arrows, no "1 / 1".
  function setNav() {
    var one = media.length < 2;
    var prev = overlay.querySelector('[data-pzoom-prev]');
    var next = overlay.querySelector('[data-pzoom-next]');
    if (prev) prev.hidden = one;
    if (next) next.hidden = one;
    if (countEl) countEl.hidden = one;
  }

  // Same as openAt, but with the list handed in instead of read from
  // [data-pzoom-data]. Used by the Make Your Own Case preview stage
  // (myoc-preview.js), which is not a gallery slide and has no media id.
  window.pzoomOpen = function (list, i, immediate) {
    if (!Array.isArray(list) || !list.length) return;
    media = list;
    idx = Math.max(0, Math.min(media.length - 1, i || 0));
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    load(immediate);
  };

  function close() {
    overlay.hidden = true;
    document.body.style.overflow = '';
    pointers = {}; dragId = null; startDist = 0; swipe = null;
  }

  function go(d) {
    idx = (idx + d + media.length) % media.length;
    load();
  }

  // Open from a click on a MAIN gallery image. Capture phase + stopPropagation
  // so the theme's draggable carousel doesn't swallow or double-handle it.
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('img.product-media__image') : null;
    if (!el || !el.closest('[data-product-media-container]')) return;

    var list = readData();
    if (!list.length) return;

    var i = -1;
    var slide = el.closest('[data-media-id]');
    if (slide) i = indexOfMediaId(list, slide.getAttribute('data-media-id'));
    if (i < 0) {
      var p = norm(el.currentSrc || el.src);
      for (var j = 0; j < list.length; j++) {
        if (norm(list[j].key) === p || norm(list[j].src) === p || norm(list[j].full) === p) { i = j; break; }
      }
    }
    if (i < 0) return;

    e.preventDefault();
    e.stopPropagation();
    openAt(i, el.currentSrc || el.src);
  }, true);

  overlay.querySelector('[data-pzoom-close]').addEventListener('click', close);
  overlay.querySelector('[data-pzoom-prev]').addEventListener('click', function () { go(-1); });
  overlay.querySelector('[data-pzoom-next]').addEventListener('click', function () { go(1); });
  overlay.querySelector('[data-pzoom-in]').addEventListener('click', function () { setScale(scale + 0.5); });
  overlay.querySelector('[data-pzoom-out]').addEventListener('click', function () { setScale(scale - 0.5); });

  // Click the dark backdrop (not the image/controls) to close.
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    setScale(scale + (e.deltaY < 0 ? 0.3 : -0.3));
  }, { passive: false });

  stage.addEventListener('dblclick', function (e) {
    e.preventDefault();
    setScale(scale > 1 ? 1 : 2.5);
  });

  stage.addEventListener('pointerdown', function (e) {
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length === 2) {
      var a = pointers[ids[0]], b = pointers[ids[1]];
      startDist = Math.hypot(a.x - b.x, a.y - b.y);
      startScale = scale;
      dragId = null;
      swipe = null;
    } else if (scale > 1) {
      dragId = e.pointerId;
      dragOX = e.clientX; dragOY = e.clientY;
      dragPX = panX; dragPY = panY;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      stage.style.cursor = 'grabbing';
    } else {
      // Not zoomed: a single finger may be a swipe. Decided on release, so a
      // short drag stays a tap and double-tap-to-zoom keeps working. No
      // pointer capture here -- the next tap must land where it was made.
      swipe = { id: e.pointerId, x: e.clientX, y: e.clientY };
    }
  });

  stage.addEventListener('pointermove', function (e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length === 2 && startDist) {
      var a = pointers[ids[0]], b = pointers[ids[1]];
      var d = Math.hypot(a.x - b.x, a.y - b.y);
      setScale(startScale * (d / startDist), false);
    } else if (dragId === e.pointerId) {
      panX = dragPX + (e.clientX - dragOX);
      panY = dragPY + (e.clientY - dragOY);
      apply(false);
    }
  });

  function endPointer(e) {
    // Swipe check first, before the map loses this pointer: it only counts if
    // this was the sole finger down, the image is not zoomed (a drag while
    // zoomed is a pan, and stealing it would make zoom unusable), and the
    // motion was clearly horizontal and long enough not to be a tap.
    var s = swipe;
    swipe = null;
    if (s && s.id === e.pointerId && scale === 1 && !startDist &&
        Object.keys(pointers).length === 1 && e.type === 'pointerup') {
      var dx = e.clientX - s.x, dy = e.clientY - s.y;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) >= SWIPE_MIN) {
        delete pointers[e.pointerId];
        go(dx < 0 ? 1 : -1);
        return;
      }
    }
    delete pointers[e.pointerId];
    if (Object.keys(pointers).length < 2) startDist = 0;
    if (dragId === e.pointerId) {
      dragId = null;
      apply(true);
      stage.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', endPointer);

  // Small public API so other components can open the viewer without faking a
  // click on a gallery image. Used by the colour configurator's mobile preview,
  // which is not part of the gallery at all.
  window.ProductZoom = {
    openByMediaId: function (mid) {
      var list = readData();
      var i = indexOfMediaId(list, mid);
      if (i < 0) return false;
      openAt(i);
      return true;
    }
  };

  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === '+' || e.key === '=') setScale(scale + 0.5);
    else if (e.key === '-') setScale(scale - 0.5);
  });
})();
